import React from 'react';
import Notification, { NotificationProps } from './notification';

interface NotificationContainerProps {
  notifications: NotificationProps[];
  onRemove: (id: string) => void;
}

const NotificationContainer: React.FC<NotificationContainerProps> = ({
  notifications,
  onRemove,
}) => {
  return (
    <div className="fixed inset-x-0 top-20 z-50 pointer-events-none pt-[env(safe-area-inset-top)]">
      <div className="mx-auto w-full max-w-md px-4 space-y-3">
        {notifications.map((notification, index) => (
          <div
            key={notification.id}
            className="pointer-events-auto w-full"
            style={{
              zIndex: 1000 - index,
            }}
          >
            <Notification
              {...notification}
              onClose={onRemove}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationContainer; 
